var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    zoomAndPan: "magnify",
    viewBox: "0 0 120 119.999999",
    height: 160,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6686e3163b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 3 L 91 3 L 91 116.859375 L 26 116.859375 Z M 26 3 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6686e3163b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8e890",
    d: "M 90.089844 44.839844 L 62.726562 5.539062 C 60.847656 2.859375 56.824219 2.859375 54.949219 5.539062 L 27.585938 44.839844 C 24.769531 48.863281 29.195312 53.960938 33.621094 51.816406 L 50.789062 43.367188 L 54.144531 112.578125 C 54.277344 115.125 56.289062 117.140625 58.835938 117.140625 C 61.386719 117.140625 63.398438 115.125 63.53125 112.578125 L 66.886719 43.367188 L 84.054688 51.816406 C 88.480469 53.960938 92.773438 48.863281 90.089844 44.839844 Z M 90.089844 44.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/arrowUp2.222853b8ecadd0e705f406b309ffedf0.svg";
export { ForwardRef as ReactComponent };